import React from 'react';
import PaymentOptions from './PaymentOptions';
import DiscountOptions from './DiscountOptions';
import ComplementaryOptions from './ComplementaryOptions';
import DocumentUpload from './DocumentUpload';

const PaymentInfoForm = ({
  formData,
  paiementFraisInscription,
  setPaiementFraisInscription,
  fraisInscription,
  montantScolarite,
  premiereTrancheModalite,
  montantPremiereTranche,
  paiementComplet,
  tarifsSup,
  optionsPaiement,
  setOptionsPaiement,
  remiseType,
  setRemiseType,
  remiseValue,
  handleRemiseChange,
  tarifsComplementaires,
  toggleTarifSup,
  modesPaiement,
  handleInputChange,
  calculerMontantActuel,
  montantVerse,
  handleMontantVerseChange,
  renderEcheances,
  montantDisponible,
  documents,
  handleDocumentUpload,
  handleDocumentRemove
}) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Section gauche - Détails des frais et remise */}
        <div className="space-y-6">
          <PaymentOptions
            paiementFraisInscription={paiementFraisInscription}
            setPaiementFraisInscription={setPaiementFraisInscription}
            fraisInscription={fraisInscription}
            montantScolarite={montantScolarite}
            premiereTrancheModalite={premiereTrancheModalite}
            montantPremiereTranche={montantPremiereTranche}
            paiementComplet={paiementComplet}
            tarifsSup={tarifsSup}
            optionsPaiement={optionsPaiement}
            setOptionsPaiement={setOptionsPaiement}
            formData={formData}
          />

          <DiscountOptions
            remiseType={remiseType}
            setRemiseType={setRemiseType}
            remiseValue={remiseValue}
            handleRemiseChange={handleRemiseChange}
            montantTotal={formData.montant_total}
          />

          <ComplementaryOptions
            tarifsComplementaires={tarifsComplementaires}
            tarifsSup={tarifsSup}
            toggleTarifSup={toggleTarifSup}
          />
        </div>

        {/* Section droite - Paiement et documents */}
        <div className="space-y-6">
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-medium text-gray-900 mb-3">Informations de paiement</h3>
            <div className="space-y-4">
              <select
                name="mode_paiement"
                value={formData.mode_paiement}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#202654] text-sm"
                required
              >
                <option value="">Sélectionner un mode de paiement</option>
                {modesPaiement.map((mode) => (
                  <option key={mode.id} value={mode.id}>
                    {mode.libelle}
                  </option>
                ))}
              </select>

              <div className="space-y-4">
                <div className="flex justify-between text-sm font-medium text-gray-700">
                  <span>Montant total actuel à payer:</span>
                  <span>{calculerMontantActuel().toLocaleString()} FCFA</span>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Montant scolarité à verser
                  </label>
                  <input
                    type="number"
                    name="montant_verse"
                    value={montantVerse}
                    onChange={handleMontantVerseChange}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#202654] text-sm"
                    required
                    min="0"
                  />
                </div>

                {/* Affichage des tranches */}
                <div className="space-y-2">
                  <h4 className="text-sm font-medium text-gray-700">Échéances des frais de scolarité</h4>
                  {renderEcheances()}
                </div>

                {montantDisponible > 0 && (
                  <div className="bg-yellow-50 border border-yellow-200 p-3 rounded-lg">
                    <p className="text-sm text-yellow-700">
                      Montant non affecté: {montantDisponible.toLocaleString()} FCFA
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <DocumentUpload
            documents={documents}
            handleDocumentUpload={handleDocumentUpload}
            handleDocumentRemove={handleDocumentRemove}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentInfoForm;
